import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${(props) => (props.$transparent ? 'transparent' : '#F7F4F2')};
  transition: all 0.15s ease-in-out;
  padding: 20px 0;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 10px 0;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    position: relative;
  }

  ${(props) =>
    props.$notSticky &&
    css`
      position: absolute;
      transition: none;
    `};

  ${(props) =>
    props.$neutral &&
    css`
      background-color: #f7f4f2;
      box-shadow: rgba(233, 220, 211, 0.4) 0 2px 10px 0;
    `};
`;

export const WrapperInner = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;

  img {
    align-self: center;
  }

  ${(props) =>
    props.$extraPadding &&
    css`
      @media (min-width: 1279px) {
        padding-left: 27px;
        padding-right: 30px;
      }

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        padding-left: 0;
        padding-right: 0;
      }
    `};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  text-wrap: nowrap;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    > *:nth-child(2) {
      display: none;
    }
    > *:first-child {
      padding: 9px 24px;
      height: 40px;
    }
  }
`;
